export default __webpack_public_path__ + "static/media/hero-servizi.b398adac.jpg";